/*
 * According to the https://github.com/mapbox/itm-backend/issues/138
 * We need to parse location params from Mapbox GL JS map in the next format `contribute/#/${lng}/${lat}/${zoom}`
 * and convert it to the `contribute/#/?l=${zoom}/${lat}/${lng}` format.
 * */

const locationParamsRegExp =
  /(([0-9]+(\.[0-9]+)?)\/([0-9]+(\.[0-9]+)?)\/([0-9]+(\.[0-9]+)?))/;

const isNumber = (val) => {
  return typeof val === 'number' && !Number.isNaN(val) && Number.isFinite(val);
};

const defaultZoomLevel = 1.7612;

const getLocation = (value) => {
  if (!value || value.includes('?')) {
    return '';
  }

  const match = locationParamsRegExp.exec(value);

  if (!match || !match.length) {
    return '';
  }

  // match[0] expected to be .../{lng}/{lat}/{zoom}
  const locationParams = match[0].split('/');
  const zoom = Number(locationParams.pop());
  const lat = Number(locationParams.pop());
  const lng = Number(locationParams.pop());

  if (!isNumber(lat) || !isNumber(lng) || !isNumber(zoom)) {
    return '';
  }

  return `${zoom || defaultZoomLevel}/${lat}/${lng}`;
};

export const rewriteGLJSUrlParams = () => {
  const l = getLocation(window.location.hash);

  if (l) {
    const searchQuery = new URLSearchParams(window.location.search);
    searchQuery.append('l', l);
    const newHashValue = `#/?${searchQuery.toString()}`;

    if (history.replaceState) {
      history.replaceState(null, '', newHashValue);
    } else {
      location.hash = newHashValue;
    }
  }
};
